/**
 * @nullable
 */
export type ArticleModelLifeCycleCode =
    | (typeof ArticleModelLifeCycleCode)[keyof typeof ArticleModelLifeCycleCode]
    | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ArticleModelLifeCycleCode = {
    I: 'I',
    G: 'G',
    P: 'P',
    O: 'O',
    E: 'E',
    N: 'N',
    NA: 'NA'
} as const;
